import { useMemo } from 'react';

import { getActualDate, getDateDifference, getDayStart } from '../utils/time';
import { useForceUpdate } from './useForceUpdate';
import { useTimeout } from './useTimeout';

import { DAY, SECOND } from '../constants/time';

export function useToday() {
  const { updates, forceUpdate } = useForceUpdate();
  const { timeout, today } = useMemo(
    function factory() {
      const actualDate = getActualDate();
      const result = { today: getDayStart(actualDate) };
      const difference = getDateDifference(actualDate, result.today, false, false, false, false, false);
      result.timeout = DAY - difference.seconds * SECOND + SECOND;
      return result;
    },
    [updates],
  );

  useTimeout({ callback: forceUpdate, timeout });

  return today;
}
